import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import DropdownMenu from '../../shared/dropdownMenu';

import {
  showChartModalForAddEdit,
  showChartModalForImport,
  showChartModalForDelete,
} from './store/actions';
import { waitForSpinnerToShowUp } from '../../shared/cursorHelpers';
import Spinner from '../../shared/spinner.component';

class ChartOfAccountsHamburgerMenu extends PureComponent {
  static propTypes = {
    canModify: PropTypes.bool.isRequired,
    isTpcGenerated: PropTypes.bool.isRequired,
    disabledActions: PropTypes.shape({
      chartNotSelected: PropTypes.bool.isRequired,
    }).isRequired,
    chartName: PropTypes.shape({
      value: PropTypes.string,
    }),
    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    showChartModalForAddEdit: PropTypes.func.isRequired,
    showChartModalForImport: PropTypes.func.isRequired,
    showChartModalForDelete: PropTypes.func.isRequired,
    downloadChart: PropTypes.func.isRequired,
  };

  state = {
    isGeneratingXlsxFile: false,
  };


  hideDropDown = () => {
    this.dropdown.hideDropDown();
  };

  showChartModalForAdd = () => {
    this.hideDropDown();
    const { showChartModalForAddEdit } = this.props;
    showChartModalForAddEdit();
  };

  showChartModalForEdit = () => {
    const { chartName, showChartModalForAddEdit } = this.props;
    showChartModalForAddEdit({
      chartName: chartName.value,
      originalChartName: chartName.value,
    });
  };

  showChartModalForImport = () => {
    const { showChartModalForImport } = this.props;

    showChartModalForImport();
  };

  showChartModalForDelete = () => {
    const { period, chartName, showChartModalForDelete } = this.props;
    showChartModalForDelete(period.name, chartName.value);
  };

  downloadChart = () => {
    this.setState({ isGeneratingXlsxFile: true }, () => {
      waitForSpinnerToShowUp({
        action: this.props.downloadChart,
        callback: () => this.setState({ isGeneratingXlsxFile: false }),
      });
    });
  };

  render() {
    const {
      canModify,
      isTpcGenerated,
      disabledActions,
    } = this.props;

    const { isGeneratingXlsxFile } = this.state;
    const tpcGeneratedAndCanModify = canModify && isTpcGenerated;

    return (
      <DropdownMenu ref={dropdown => this.dropdown = dropdown} contentClassName="hamburger-menu">
        {canModify && (
          <button
            className="hamburger-action link-button"
            tabIndex="0"
            onClick={this.showChartModalForAdd}
          >
            Add Chart
          </button>
        )}
        {tpcGeneratedAndCanModify && (
          <button
            className="hamburger-action link-button"
            tabIndex="0"
            onClick={this.showChartModalForDelete}
            disabled={disabledActions.chartNotSelected}
          >
            Delete Chart
          </button>
        )}
        {tpcGeneratedAndCanModify && (
          <button
            className="hamburger-action link-button"
            tabIndex="0"
            onClick={this.showChartModalForEdit}
            disabled={disabledActions.chartNotSelected}
          >
            Edit Chart Name
          </button>
        )}
        <button
          className="hamburger-action link-button"
          tabIndex="0"
          disabled={disabledActions.chartNotSelected}
          onClick={this.downloadChart}
        >
          {isGeneratingXlsxFile
            ? (
              <span>
                <Spinner small /> Exporting
              </span>
            ) : 'Export Chart'
          }
        </button>
        {tpcGeneratedAndCanModify && (
          <button
            className="hamburger-action link-button"
            tabIndex="0"
            onClick={this.showChartModalForImport}
            disabled={disabledActions.chartNotSelected}
          >
            Import Chart
          </button>
        )}
      </DropdownMenu>
    );
  }
}

export default connect(
  null,
  {
    showChartModalForAddEdit,
    showChartModalForImport,
    showChartModalForDelete,
  }
)(ChartOfAccountsHamburgerMenu);
